import React, { useEffect, useState } from 'react';
import {
  MinusIcon,
  MoreIcon,
  PlaneIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { AutoComplete } from '@womcorp/wom-miwom-ui-kit/dist/components/AutoComplete';
import { PinPukHelpIcon as DeviceIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import { navigate } from 'gatsby';
import { GoogleTagManager } from '../../helpers';

import {
  RoamingContainerStyled,
  RoamingContentStyled,
  RoamingHeaderStyled,
  RoamingSelectorStyled,
  IconContainerStyled,
  CountriesContainerStyled,
  FrequentCountriesContainerStyled,
  FrequentCountrieStyled,
  ChevronStyled,
  SeeMoreButtonStyled,
} from './styles/RoamingSearchStyled';
import countries from './data/countries.json';
import { useGlobalData } from '../../contextProvider/GlobalDataContext';
import RoamingSkeleton from './RoamingSkeleton/RoamingSkeleton';
import { getFrequentCountries } from '../../services/Contentful';

const Roaming = () => {
  const [frequentCountries, setFrequentCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showHiddenCountries, setShowHiddenCountries] = useState(false);
  const { 'roaming-title': roamingTitle = {} } = useGlobalData();
  const maxSlice = !showHiddenCountries ? 5 : frequentCountries.length;
  const getFrequentCountriesData = () => {
    return getFrequentCountries()
      .then(([{ items: frequentCountriesRoaming }]) => {
        setFrequentCountries(frequentCountriesRoaming);
      })
      .catch(() => {
        setFrequentCountries([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/tienda/bolsas/roaming/buscador',
      pagename: 'Tienda - Bolsas - Roaming - Buscador',
    });
    getFrequentCountriesData();
  }, []);

  if (loading) return <RoamingSkeleton />;

  return (
    <>
      <RoamingHeaderStyled>
        <IconContainerStyled>
          <DeviceIcon />
        </IconContainerStyled>
        <p>{roamingTitle.title}</p>
      </RoamingHeaderStyled>
      <RoamingContainerStyled>
        <RoamingContentStyled>
          <PlaneIcon />
          <h1>¿En qué país utilizarás tu roaming?</h1>
        </RoamingContentStyled>
        <RoamingSelectorStyled>
          <h2>Selecciona el país</h2>
          <AutoComplete
            options={countries}
            label="¿Dónde viajarás?"
            notFound="No se encontró ningún país"
            onChange={e => {
              if (e?.value) {
                const isFrequentcountry = frequentCountries.find(
                  country => country.value === e.value
                );
                const flag = isFrequentcountry?.flagIcon?.url ?? '';
                navigate(
                  `/marketplace/categorias/bolsas-roaming?code=5&country=${e.value}`,
                  {
                    state: {
                      icon: flag,
                      countryName: e.label,
                    },
                  }
                );
              }
            }}
          />
        </RoamingSelectorStyled>
        {frequentCountries.length >= 1 && (
          <FrequentCountriesContainerStyled>
            <h1>Destinos recurrentes</h1>
            <CountriesContainerStyled>
              {frequentCountries
                .slice(0, maxSlice)
                .map(({ title, flagIcon, value }) => (
                  <FrequentCountrieStyled
                    key={title}
                    onClick={() => {
                      navigate(
                        `/marketplace/categorias/bolsas-roaming?code=5&country=${value}`,
                        {
                          state: {
                            icon: flagIcon?.url,
                            countryName: title,
                          },
                        }
                      );
                    }}
                  >
                    <img src={flagIcon?.url} alt={flagIcon?.description} />
                    <p>{title}</p>
                    <ChevronStyled />
                  </FrequentCountrieStyled>
                ))}
            </CountriesContainerStyled>

            {frequentCountries.length > 5 && (
              <SeeMoreButtonStyled
                onClick={() => setShowHiddenCountries(!showHiddenCountries)}
              >
                {!showHiddenCountries ? (
                  <>
                    VER MÁS <MoreIcon />
                  </>
                ) : (
                  <>
                    OCULTAR <MinusIcon />
                  </>
                )}
              </SeeMoreButtonStyled>
            )}
          </FrequentCountriesContainerStyled>
        )}
      </RoamingContainerStyled>
    </>
  );
};

export default Roaming;
